import React from 'react';
import {Navigate} from 'react-router-dom';
import useAuth from "../hooks/use-auth";

interface GuardEmailVerifiedProps {
    children: React.ReactNode;
}

const GuardEmailVerified: React.FC<GuardEmailVerifiedProps> = ({children}) => {
    const {currentUser} = useAuth();

    if (currentUser && !currentUser.hasEmailVerified) {
        return <Navigate to="/email-verification" replace/>;
    }

    return <>{children}</>;
};

export default GuardEmailVerified;
